import React, { useState, useEffect } from "react";
import Tada from "react-reveal/Tada";
// Css
import classes from "./Logo.module.scss";

interface Props {
  maxWidth?: string;
  onClick?: () => void;
}

const Logo: React.FC<Props> = ({ maxWidth = "500px", onClick }) => {
  const [toggle, setToggle] = useState<Boolean>(false);
  useEffect(() => setToggle(true), []);

  const handleClick = () => {
    setToggle(!toggle);
    if (onClick) onClick();
  };

  return (
    <Tada spy={toggle}>
      <img
        style={{ maxWidth }}
        className={classes.image}
        src="assets/img/board/fascist-vs-liberal.svg"
        alt=""
        onClick={handleClick}
      />
    </Tada>
  );
};

export default Logo;
